<div *ngIf="satisfactions && satisfactions.length>0" >
  <app-satisfaction-rate [satisfaction]="satisfaction" *ngFor="let satisfaction of satisfactions"></app-satisfaction-rate>
</div>